// Contract addresses for different networks
const addresses = {
  43113: {
    name: "fuji",
    assetTokenizationManager: "0xa60814985219A288454467860a5FBa84f384A527",
    verifyingOperatorVault: "0x8eff10d7aEd87a137A0a05D65f1afdF1062Aa442",
    realEstateRegistry: "0x399eE27AA7cB7791e129A29D003665A8d3336Df7",
    usdc: "0xbf856058aD6CC34c3bdfA574e13C911BD215220e",
    estateVerification: "0xDc4ea519B0c9435662586EdE14CFDe3f6fda4C33",
  },
  11155111: {
    name: "sepolia",
    assetTokenizationManager: "0x03887eF5E94C2cb1A4a1f62E8656BB1Adb485F07",
    verifyingOperatorVault: "0x5E064E3C1b563e32f28980E68785a4967c298052",
    realEstateRegistry: "0xe7B1cc3831ADE7e9ac133A0CB08aC74E047086C6",
    usdc: "0xd611ccF96d2b8445A8731F4792C8Cc3871f96AA3",
    estateVerification: "0x9A8084e6e9fA9616A9EE1CBf8d31d4aCD6B2467B",
  }
};

export default addresses;
